import { render, staticRenderFns } from "./MarginBenefit.vue?vue&type=template&id=2e3e1b52&scoped=true&"
import script from "./MarginBenefit.vue?vue&type=script&lang=js&"
export * from "./MarginBenefit.vue?vue&type=script&lang=js&"
import style0 from "./MarginBenefit.vue?vue&type=style&index=0&id=2e3e1b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3e1b52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VIcon,VRow,VSimpleTable})
